import {
  Dropdown as PrimeDropdown,
  DropdownProps as PrimeDropdownProps,
  Dropdown as PrimeReactDropdown,
} from 'primereact/dropdown'
import { forwardRef, useImperativeHandle, useRef } from 'react'
import './Dropdown.module.scss'

export type DropdownProps = PrimeDropdownProps & {
  optionValue?: any
  filterTextValue?: string
}

export type DropdownRef = PrimeDropdown & {
  resetFilter: () => void
}

const Dropdown = forwardRef<DropdownRef, DropdownProps>((props, ref) => {
  const dropdownRef = useRef<PrimeDropdown>(null)

  useImperativeHandle(ref, () => {
    const instance = dropdownRef.current as PrimeDropdown

    return Object.assign(instance ?? ({} as PrimeDropdown), {
      resetFilter: () => {
        if (props.onFilter) {
          props.onFilter({
            filter: '',
          } as any)
        }
      },
    }) as DropdownRef
  })

  const valueTemplate = (option: any, props: DropdownProps) => {
    const selectedValue = props.options?.find(option => option[props.optionValue] === props?.value)
    if (!selectedValue) return props.placeholder || 'empty'

    return selectedValue[props.optionLabel ?? ''] || 'empty'
  }

  return (
    <PrimeReactDropdown
      valueTemplate={props.optionValue === undefined ? undefined : valueTemplate}
      filterTemplate={
        props.onFilter && props.filterTextValue !== undefined
          ? () => (
              <div className="p-dropdown-filter-container">
                <input
                  type="text"
                  className="p-dropdown-filter p-inputtext p-component"
                  onChange={e => props.onFilter!({ filter: e.target.value } as any)}
                  value={props.filterTextValue}
                />
                <i className="p-dropdown-filter-icon pi pi-search"></i>
              </div>
            )
          : undefined
      }
      {...props}
    />
  )
})

export default Dropdown
